<template>
  <div class="box1">
    <div id="block"></div>
    <div class="banner">
     
    </div>
    <vue-seamless-scroll
      :data="tabList"
      :class-option="classOption1"
      class="seamless-warp"
    >
      <div class="demo">
        <div class="item" v-for="(item, index) in tabList" :key="index">
          <p>{{ item.tit }}</p>
          <p>{{ item.txt }}</p>
        </div>
      </div>
    </vue-seamless-scroll>
  </div>
</template>

<script>
import vueSeamlessScroll from "vue-seamless-scroll";
export default {
  components: {
    vueSeamlessScroll,
  },
  data() {
    return {
      tabList: [
        { tit: "离线数仓能力", txt: "满足企业搭建数仓的需求" },
        { tit: "实时数仓能力", txt: "满足企业搭建实时数仓的需求" },
        { tit: "BI开发能力", txt: "解决企业数据可视化问题" },
        { tit: "调度脚本编写能力", txt: "解决大数据任务调度问题" },
      ],
    };
  },
  computed: {
    classOption1() {
      return {
        step: 0.5, // 数值越大速度滚动越快
        limitMoveNum: 4, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 2, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 10000, // 单步运动停止的时间(默认值1000ms)
      };
    },
  },
};
</script>

<style lang="less" scoped>
.box1 {
  position: relative;

  width: 750px;

  #block {
    width: 100%;
    height: 88px;
  }
  .banner {
    position: relative;
    padding-top: 80px;
    width: 100%;
    height: 530px;
    background: url("../../../assets/coursePage/pythonData/box1/banner.png")
      no-repeat;
    background-size: cover;
    background-position: center;
    box-sizing: border-box;
    
  }
  .seamless-warp {
    margin-top: 64px;
    width: 100%;

    position: relative;
    z-index: 9;
    margin-top: -98px;
    position: absolute;
    overflow: hidden;
    .demo {
      display: flex;
      height: 230px;
    }
    .item {
      height: 160px;
      flex-shrink: 0;
      background: linear-gradient(180deg, #e5f6ff 0%, #ffffff 100%);
      box-shadow: 0px 12px 32px 0px rgba(0, 0, 0, 0.044);
      border-radius: 16px;
      border: 2px solid #ffffff;
      padding: 32px 0px 32px 32px;
      flex-shrink: 0;
      box-sizing: border-box;
      margin-left: 32px;
      margin-top: 20px;
      p:nth-child(1) {
        font-size: 28px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #0080ff;
        line-height: 44px;
      }
      p:nth-child(2) {
        margin-top: 8px;
        font-size: 26px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #525366;
        line-height: 44px;
      }
    }
    .item:nth-child(1) {
      width: 362px;
    }
    .item:nth-child(2) {
      width: 414px;
    }
    .item:nth-child(3) {
      width: 365px;
    }
    .item:nth-child(4) {
      width: 365px;
    }
  }
}
</style>
